import {
  CreateEnterpriseFrameworkDto,
  Enterprise,
} from '@/stores/EnterpriseStore/EnterpriseStore.consts';

export const convertFrameworksArrayToObject = (
  frameoworks: CreateEnterpriseFrameworkDto[]
): Record<string, CreateEnterpriseFrameworkDto> => {
  return frameoworks.reduce((acc: Record<string, CreateEnterpriseFrameworkDto>, framework) => {
    acc[framework.code] = framework;
    return acc;
  }, {});
};

export const convertEnterpriseToFormFields = (selected: Enterprise) => {
  return {
    name: selected.name,
    description: selected.description,
    emails: selected.emails.join(','),
    frameworks: selected.frameworks.map((framework) => framework.code),
    frameworksSettings: convertFrameworksArrayToObject(selected.frameworks),
    expiresAt: selected.expiresAt,
  };
};
